<payarc-dialog-shell [title]="data.title || 'Please confirm'" (closed)="cancel()">
  <p class="cfm-msg">{{ data.message }}</p>

  <div footer class="cfm-foot">
    <button type="button" payarcButton="ghost" (click)="cancel()">{{ data.cancelBtn || 'Cancel' }}</button>
    <button type="button" [payarcButton]="data.danger ? 'destructive' : 'primary'" (click)="confirm()">
      {{ data.confirmBtn || 'Confirm' }}
    </button>
  </div>
</payarc-dialog-shell>
